import React, { useCallback, useContext, useEffect, useState } from 'react'
import { ButtonHeading, CommonInput, CommonModal, CustomSelect } from 'components'
import { AddEditLrModal, AddInvoiceTemplateModal, AddItemGroupModal, AddItemModal, AddLrModal, AddNewSeriesModal, ConfirmModalFor, InvoiceLrPodModal, InvoicePrintModal, InvoiceReport, LrDetailModal, LrSeriesModal, SupplierReport, ThankyouModal } from 'modals'
import { getLRDeaultColumn, getLrCountData, getMainLrListData, updateUserLrColumns } from '_services/accountsServices/lrServices'
import StorageService from 'utils/StorageServices/StorageServices'
import { CustomTableNew } from 'components/CustomTable'
import moment from 'moment';
import AddEditConsignor from 'modals/AddEditConsignor/AddEditConsignor'
import { UserContext } from 'context'
import { BillSummaryDetails } from '.'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { getDetailsInvoiceBillRaise, getDetailsOfSummaryData, getInvoiceBillRaise, lrDeleteForSummaryDetails } from '_services/invoiceBillRaiseServices'
import Loading from 'pages/Loading'
import { getConsignorDropdownListData, getLrTemplateDropdownListData } from '_services/dropdownServices/dropdownService'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { updateSearchValue } from 'features/lrFilterServices/lrSearchSlice'
import { API, AppConfig } from 'lib'
import toast from 'react-hot-toast'
import './billraise.css'

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const BillRaiseDetails = () => {

  const { id } = useParams();
  const query = useQuery();
  const ct = query.get('ct'); // ct = create bill raise parameter
  const { masterData, setIsMaterialIndex, invoiceTableToggle, setInvoiceTableToggle } = useContext(UserContext)
  const [isOpenThankyouModal, setIsOpenThankyouModal] = useState(false);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [billRaiseDetailsData, setBillRaiseDetailsData] = useState({});

  const [show, setShow] = useState(false);
  const [showBackModal, setShowBackModal] = useState(false);
  const [showLrPodModal, setShowLrPodModal] = useState(false);

  const [isDropDownFilter, setIsDropDownFilter] = useState({
    consignor_id: '',
    template_id: '',
  })

  const [lrTemplateList, setLrTemplateList] = useState([])
  const [consignorList, setConsignorList] = useState([]);

  const getSearchValue = useSelector((state) => state.lrSearch);
  const [isOpenInvoiceTemplate, setIsOpenInvoiceTemplate] = useState(false);

  const [openForDownLoad, setOpenForDownLoad] = useState(false)

  // invoice details lr pod
  const [format, setFormats] = useState({
    lr_with_pod: 0,
    lr_id: ''
  })
  // invoice details lr pod

  // Lr table start 

  const [columns, setColumns] = useState([]);
  const [apiData, setApiData] = useState([]);
  const [filterableColumns, setFilterableColumns] = useState([]);
  const [isMasterFilter, setIsMasterFilter] = useState(true);
  const [error, setError] = useState(true);
  const [loading, setLoading] = useState(true);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [activeStatus, setActiveStatus] = useState(0);
  const [isTableHide, setIsTableHide] = useState(true);
  const [totalRecords, setTotalRecords] = useState('')
  const [showLrDetail, setShowLrDetail] = useState(false)

  let isToken = localStorage.getItem("token");
  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const [lrDeleteConfirm, setLrDeleteConfirm] = useState(false);
  const [loadingLrDelete, setLoadingLrDelete] = useState(false);

  const handleDetailsAction = (data) => {
    setShowLrDetail(data);
  }

  const transformData = (data) => {
    return data.map(item => ({
      originalData: item,
      lr_number: item?.lr_number ? <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> {item?.lr_number} </a> </div> : <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction(item)}> <a className='_avPointer'> View </a> </div>,
      trip_id: item?.trip_id?.trip_number ? <div className='_tblText'>{item?.trip_id?.trip_number} </div> : '-',
      plan_id: item?.plan_id?.indent_number ? <div className='_tblText'>{item?.plan_id?.indent_number} </div> : '-',
      invoice_date: item?.invoice_date ? <div className='_dateNtime'>
        <span className='_tblText'>{moment(item?.invoice_date).format('DD MMM YYYY')}</span>
        <span className='_lgtText'>{moment(item?.invoice_date).format('hh:mm A')}</span>
      </div> : '-',
      dispatch_date: item?.trip_id?.dispatch_date ? <div className='_dateNtime'>
        <span className='_tblText'>{moment(item?.trip_id?.dispatch_date).format('DD MMM YYYY')}</span>
        <span className='_lgtText'>{moment(item?.trip_id?.dispatch_date).format('hh:mm A')}</span>
      </div> : '-',
      consignor_name: item?.consignor_id?.name ? <div className='_tblText _oneLine_tx'>{item?.consignor_id?.name}</div> : '-',
      branch_name: item?.branch_id?.branch ? <div className='_tblText _oneLine_tx'>{item?.branch_id.branch}</div> : '-',
      // from_location: item?.from_location ? item?.from_location : '-',
      from_location: item?.from_location ? (
        <div className='_locationWid_bx' >
          <p className="_tblText">{item.from_location}</p>
          {((item.unit_id && item.unit_id.code) || (item.unit_id && item.unit_id.name)) && <p className="_lgtText">{item.unit_id && item.unit_id.code && item.unit_id.code} {(item.unit_id.code && item.unit_id.name) && `|`} {item.unit_id && item.unit_id.name && item.unit_id.name} </p>}
        </div>
      ) : '-',
      // to_location: item?.to_location ? item?.to_location : '-',
      to_location: item?.to_location ? (
        <div className='_locationWid_bx'>
          <p className="_tblText">{item.to_location}</p>
          {((item.consignee_id && item.consignee_id.code) || (item.consignee_id && item.consignee_id.name)) && <p className="_lgtText">{item.consignee_id && item.consignee_id.code && item.consignee_id.code} {(item.consignee_id.code && item.consignee_id.name) && `|`} {item.consignee_id && item.consignee_id.name && item.consignee_id.name} </p>}
        </div>
      ) : '-',
      invoice_number: item?.invoice_number ? <div className='_tblText'>{item?.invoice_number}</div> : '-',
      sap_invoice_number: item?.sap_invoice_number ? <div className='_tblText'>{item?.sap_invoice_number}</div> : '-',
      gst_number: item?.gst_number ? <div className='_tblText'>{item?.gst_number}</div> : '-',
      po_number: item?.po_number ? <div className='_tblText'>{item?.po_number}</div> : '-',
      mlr_number: item?.mlr_number ? <div className='_tblText'>{item?.mlr_number}</div> : '-',
      // lr_status: item?.lr_status ? item?.lr_status : '-',
      lr_status: item?.lr_status ? (
        // <span className="bg-success"> {item.lr_status} </span>
        <span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span>
      ) : '-',
      pod_status: item?.pod_status ? <span className={masterData?.pod_status[item?.pod_status] === 'Pending' ? '_lrPending_status' : (masterData?.pod_status[item?.pod_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.pod_status[item?.pod_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.pod_status[item?.pod_status] === 'Received' ? '_lrDelivered_status' : (masterData?.pod_status[item?.pod_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.pod_status[item?.pod_status] ? masterData?.pod_status[item?.pod_status] : ''} </span>
        : '-',
      created_by: item?.created_by ? <div className='_tblText'>{item?.created_by}</div> : '-',
      eway_bill_number: item?.eway_bill_number ? <div className='_tblText'>{item?.eway_bill_number}</div> : '-',
      eway_bill_date: item?.eway_bill_date ? <div className='_dateNtime'>
        <span className='_tblText'>{moment(item?.eway_bill_date).format('DD MMM YYYY')}</span>
        <span className='_lgtText'>{moment(item?.eway_bill_date).format('hh:mm A')}</span>
      </div> : '-',
      eway_expiry_date: item?.eway_expiry_date ? <div className='_dateNtime'>
        <span className='_tblText'>{moment(item?.eway_expiry_date).format('DD MMM YYYY')}</span>
        <span className='_lgtText'>{moment(item?.eway_expiry_date).format('hh:mm A')}</span>
      </div> : '-',
      at_party_point_date: (item?.lr_process?.length > 0 && item?.lr_process?.find((el) => el?.type === 'party_point')?.date) ? <div className='_tblText'>{moment(item?.lr_process?.find((el) => el?.type === 'party_point')?.date).format('DD MMM YYYY')}</div> : '-',
      eway_bill_status: item?.eway_bill_status ?
        <span className={masterData?.eway_bill_status[item?.eway_bill_status] === 'Without Eway' ? '_lrPending_status' : (masterData?.eway_bill_status[item?.eway_bill_status] === 'Active Eway' ? '_lrInTransit_status' : (masterData?.eway_bill_status[item?.eway_bill_status] === 'Expiring Today' ? '_lrPartyPoint_status' : ((masterData?.eway_bill_status[item?.eway_bill_status] === 'Closed' ? '_lrDelivered_status' : '_lrPartyPoint_status'))))}> {masterData?.eway_bill_status[item?.eway_bill_status] ? masterData?.eway_bill_status[item?.eway_bill_status] : ''} </span>
        : '-',
      total_qty: item?.total_qty ? <div className='_tblText'>{item?.total_qty}</div> : '-',
      total_kot: item?.total_kot ? <div className='_tblText'>{item?.total_kot}</div> : '-',
      total_freight: item?.total_freight ? <div className='_tblText'> &#x20B9; {item?.total_freight}</div> : '-',
      dispatch_date: item?.dispatch_date ? <div className='_tblText'>{moment(item?.dispatch_date).format('DD MMM YYYY')}</div> : '-',
      eway_bill_status: item?.eway_bill_status === 0 ? <span className='_lrPending_status'>  Pending </span> : '-',
      vehicle_no: item?.vehicle_no ? <div className='_tblText'>{item?.vehicle_no}</div> : '-',
      vehicle_ownership: item?.vehicle_ownership ? <div className='_tblText'>{masterData?.vehicle_ownership[item?.vehicle_ownership]}</div> : '-',
      lorry_type: item?.lorry_type ? <div className='_tblText'>{item?.lorry_type}</div> : '-',
      supplier_name: item?.supplier_name ? <div className='_tblText'>{item?.supplier_name}</div> : '-',
      vehicle_type: item?.vehicle_type ? <div className='_tblText'>{item?.vehicle_type}</div> : '-',
      indent_number: item?.indent_number ? <div className='_tblText'>{item?.indent_number}</div> : '-',
      pod_date: item?.pod_date ? <div className='_tblText'>{moment(item?.pod_date).format('DD MMM YYYY')}</div> : '-',
      pod_file: item?.pod_file ? <div className='_tblText'>{item?.pod_file?.length ? item?.pod_file?.length : 0}</div> : '-',
      trip_number: item?.trip_number ?
        <div className='_tblText'>
          <Link to={`/trip/addtrip/dispatched/${item?.trip_id?._id}`}>
            {item?.trip_number}
          </Link>
        </div> : '-',
      driver_name: item?.driver_name ? <div className='_tblText'>{item?.driver_name}</div> : '-',
      delivery_date: item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date ? moment(item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date).format('DD MMM YYYY') : '',
      delivery_time: item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date ? moment(item?.lr_process?.find((el) => (el?.type === 'delivered') ? el : '')?.date).format('hh:mm A') : '',
      // balance: <> {item?.balance ? <div className='_tblText'> &#x20B9; {item?.balance}</div> : '-'} </>,
      // claim_receivable: <> {item?.claim_receivable ? item?.claim_receivable : '-'} </>,
      // claim_payable: <> {item?.claim_payable ? item?.claim_payable : '-'} </>,
      balance: item?.lr_freight?.balance ? <div className='_tblText'> &#x20B9; {item?.lr_freight?.balance?.toFixed(2)}</div> : '-',
      claim_receivable: item?.lr_freight?.pending_receivable ? <div className='_tblText'> &#x20B9; {item?.lr_freight?.pending_receivable ? +item?.lr_freight?.pending_receivable?.toFixed(2) : 0}</div> : '-',
      claim_payable: item?.lr_freight?.pending_payble ? <div className='_tblText'> &#x20B9; {item?.lr_freight?.pending_payble ? +item?.lr_freight?.pending_payble?.toFixed(2) : 0}</div> : '-',
      total_weight: item?.total_weight ?
        <div className='_tblText'>{item?.total_weight} kg </div>
        : '-'
    }));
  };

  const getData = async (page, lrStatus) => {
    try {
      let postData = {
        company_id: StorageService.getCompanyId(),
        billraise_id: id,
        consignor_id: isDropDownFilter?.consignor_id?.value,
        template_id: isDropDownFilter?.template_id?.value,
        limit: pageLimit,
        offset: currentPage,
        search: getSearchValue?.search ? getSearchValue?.search : '',
      }
      const response = await getDetailsInvoiceBillRaise(postData);
      setColumns(response?.data?.lr_columns);
      setApiData(transformData(response?.data?.lr_list));
      setFilterableColumns(response?.data?.lr_filter_columns);
      setIsMasterFilter(true);
      setTotalPages(Math.ceil(response?.data?.total_record / pageLimit));
      setTotalRecords(response?.data?.total_record)
      // setFilterableColumns(response.filterableColumns);
      // setIsMasterFilter(response.isMasterFilter);
    } catch (error) {
      console.error('Error fetching master data:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  const updateLrColumns = async (data) => {
    let postData = {
      company_id: StorageService.getCompanyId(),
      lr_columns: data,
    }
    try {
      const response = await updateUserLrColumns(postData);
      setColumns(response?.data?.lr_columns);
      setApiData(transformData(response?.data?.lr_list));
      setFilterableColumns(response?.data?.lr_filter_columns);
      setIsMasterFilter(true);
      setTotalPages(Math.ceil(response?.data?.total_record / pageLimit));
      setTotalRecords(response?.data?.total_record)
      // setFilterableColumns(response.filterableColumns);
      // setIsMasterFilter(response.isMasterFilter);
    } catch (error) {
      console.error('Error fetching master data:', error);
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (consignorList?.length > 0 && lrTemplateList?.length > 0) {
      const delayDebounceFn = setTimeout(() => {
        getData(currentPage, activeStatus);
      }, 500)

      return () => clearTimeout(delayDebounceFn)
    }
    setIsMaterialIndex('');
  }, [masterData, currentPage, activeStatus, isDropDownFilter, isTableHide, getSearchValue])

  const handlePageChange = (page) => {
    setCurrentPage(page);
  }

  // Lr table end

  const handleStatusChange = async (lrStatus) => {
    setIsTableHide(false);
    if (lrStatus !== activeStatus) { // Check if status actually changes
      setActiveStatus(lrStatus); // Update activeStatus
      setCurrentPage(1); // Reset page to 1 when status changes

      // Debounce the API call to prevent multiple rapid calls
      await new Promise(resolve => setTimeout(resolve, 300)); // Adjust debounce time as needed

      getData(1, lrStatus);
    }
  };

  const handleComponentChange = (e) => {
    setIsTableHide(true)
  }

  const renderStatusFilters = () => (
    <div className='_tabUr_bx _minTab_ur'>
      <button className={`tabCst_btn ${isTableHide ? '_btnActive' : ''}`} onClick={(e) => handleComponentChange(e)}> <span > Summary </span> </button>
      <button className={`tabCst_btn ${!isTableHide ? '_btnActive' : ''}`} onClick={() => handleStatusChange(0)}> <span > LR </span> </button>
    </div>
  );

  const getTemplateLrList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        search: "",
      }
      const res = await getLrTemplateDropdownListData(object);
      if (res?.responseCode === 200) {
        let responseData = res?.data?.list?.map((el) => {
          return {
            label: el?.name,
            value: el?._id,
          }
        })
        setLrTemplateList(responseData);
      }
    } catch (error) {
      // throw error;
    }
  }

  const getDropdownDataConsignorList = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        firm_id: StorageService.getFirmId(),
        limit: 100,
        offset: 1,
        search: '',
      }
      const res = await getConsignorDropdownListData(object);
      setLoading(false);
      if (res?.responseCode == 200) {
        setConsignorList(res?.data?.consignor_list)
      }
    } catch (error) {
      throw error;
    }
  }

  useEffect(() => {
    // getTemplateLrList();
    getDropdownDataConsignorList();
    // isOpenInvoiceTemplate
  }, [StorageService.getCompanyId()])

  useEffect(() => {
    if (lrTemplateList?.length > 0) {
      setIsDropDownFilter((s) => ({
        ...s,
        template_id: lrTemplateList[0],
      }))
    }
  }, [lrTemplateList])

  useEffect(() => {
    setIsDropDownFilter((s) => ({
      ...s,
      consignor_id: {
        label: billRaiseDetailsData?.consignor_id?.name,
        value: billRaiseDetailsData?.consignor_id?._id,
      }
    }))
  }, [billRaiseDetailsData?.consignor_id])

  useEffect(() => {
    getTemplateLrList();
  }, [isOpenInvoiceTemplate, StorageService.getCompanyId()])

  const showingDropdownFilters = () => {
    return <>
      {!isTableHide &&
        <>
          <div className="_fleX_inds _blRaise_fits">
            <div className="_divForth">
              <CommonInput
                type="text"
                label="Party"
                placeholder="Party"
                disabled={true}
                value={isDropDownFilter?.consignor_id?.label ? isDropDownFilter?.consignor_id?.label : ''}
              />
            </div>
            <div className="_divForth">
              <CustomSelect
                label="Template Format"
                placeholder="Template Format"
                options={lrTemplateList}
                name="template_id"
                value={isDropDownFilter?.template_id}
                isAddButton={true}
                addButtonAction={(e) => setIsOpenInvoiceTemplate(true)}
                onSelect={(data) => setIsDropDownFilter((s) => ({ ...s, template_id: data }))}
              />
            </div>
          </div>
        </>
      }
    </>
  }

  const callInvoiceDetailsApi = async () => {
    try {
      let object = {
        company_id: StorageService.getCompanyId(),
        billraise_id: id,
      }
      const res = await getDetailsOfSummaryData(object);
      if (res?.responseCode == 200) {
        setBillRaiseDetailsData(res?.data?.billraise);
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      // throw error;
    }
  }

  useEffect(() => {
    if (id && StorageService.getCompanyId()) {
      setLoading(true);
      callInvoiceDetailsApi();
    }
  }, [id, StorageService.getCompanyId()])

  const resetLRTableColumn = async () => {
    try {
      let postData = {
        company_id: StorageService.getCompanyId(),
      }
      const response = await getLRDeaultColumn(postData);
      if (response?.responseCode == 200) {
        setColumns(response?.data?.lr_columns)
      }

    } catch (error) {
      console.error('Error fetching deault LR table column', error);
    } finally {
    }
  }

  const handleOnChange = async (name, value) => {
    dispatch(updateSearchValue(value ? value : ''))
  };

  let AddtemplateInvoiceModal = {
    isOpen: isOpenInvoiceTemplate,
    closeModal: (e) => setIsOpenInvoiceTemplate(!isOpenInvoiceTemplate),
    modalMainClass: "_dashCommon_Modal _lgModal blurModal",
    modalTitle: "Create Template",
    submitTitle: "Create Template",
    data: masterData?.billraise_lr_list_columns,
    isDivForth: true,
    columns: masterData?.billraise_lr_list_columns,
    filterableColumns: filterableColumns,
    data: apiData,
    setColumns: (data) => updateLrColumns(data)
  }

  const getDownloadLrDetailReport = async () => {
    setInvoiceLoading(true)
    try {
      const payload = {
        company_id: StorageService.getCompanyId(),
        billraise_id: id
      }
      const response = await fetch(`${AppConfig.api_baseurl}${API.LR_EXCEL_REPORT}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': `${isToken}`,
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        if (errorBody?.responseMessage) {
          toast.error(errorBody?.responseMessage);
        }
        throw new Error(`Server Error (${errorBody?.responseMessage})`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Invoice_report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      setInvoiceLoading(false);
    } catch (error) {
      if (error?.responseMessage) {
        toast.error(error?.responseMessage);
      }
      setInvoiceLoading(false);
    }
  }

  let invoiceBuiltyPrintModal = {
    isOpen: show,
    closeModal: (e) => setShow(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Invoice",
    submitTitle: "Print Invoice",
    therdSubmitTitle: "Download Excel",
    downloadPdf: 'Download Pdf',
    invoiceFormats: billRaiseDetailsData,
    confirmBox: (e) => setShowBackModal(true)
  }

  const submitLeaveModalProps = () => {
    setShowBackModal(false)
    navigate(`/setting/company?tbn=3`)
  }

  const backModalProps = {
    show: showBackModal,
    closeModal: (e) => setShowBackModal(false),
    title: "Information",
    submitTitle: "Add Format",
    onSubmit: submitLeaveModalProps,
    confirmModal: "confirmModal",
  };

  const invoiceLrPodProps = {
    show: showLrPodModal,
    closeModal: (e) => setShowLrPodModal(false),
    title: "Information",
    // submitTitle: "Add Format",
    // onSubmit: submitLeaveModalProps,
    confirmModal: "confirmModal",
  };

  const closeHandlerFunction = () => {
    // setInvoiceTableToggle(false);
    const params = new URLSearchParams(location.search);
    params.set('ct', null);
    navigate(`${location.pathname}`); // ?${params.toString()}
  }

  let thankyouModalProps = {
    isOpen: isOpenThankyouModal,
    closeModal: (e) => setIsOpenThankyouModal(!isOpenThankyouModal),
    modalMainClass: "_dashCommon_Modal _smModal",
    callNavigateFunction: closeHandlerFunction,
    closeButtonNotShow: false,
  }

  useEffect(() => {
    if (ct) {
      setIsOpenThankyouModal(true)
      const clear = setTimeout(() => {
        closeHandlerFunction();
        setIsOpenThankyouModal(false);
      }, 3000);

      return () => {
        clearTimeout(clear);
      };
    }
  }, [ct])

  const deleteItemHandler = (element) => {
    setLrDeleteConfirm(element);
  }

  const submitLrDeleteHandler = async () => {
    setLoadingLrDelete(true);
    try {
      let array = lrDeleteConfirm?._id ? [lrDeleteConfirm?._id] : [];
      let object = {
        company_id: StorageService.getCompanyId(),
        billraise_id: lrDeleteConfirm?.billraise_id,
        select_lr_ids: array,
      }
      const res = await lrDeleteForSummaryDetails(object);
      if (res?.responseCode == 200) {
        callInvoiceDetailsApi();
        if (res?.responseMessage) {
          toast.success(`${res?.responseMessage}`);
        }
        setLoadingLrDelete(false);
        setLrDeleteConfirm(false)
      } else {
        if (res?.responseMessage) {
          toast.success(`${res?.responseMessage}`);
        }
        setLoadingLrDelete(false);
      }
    } catch (error) {
      setLoadingLrDelete(false);
    }
  }

  let confirmObject = {
    isOpen: lrDeleteConfirm,
    closeModal: (e) => setLrDeleteConfirm(false),
    modalTitle: "Confirmation",
    submitTitle: "Confirm",
    cancleTitle: "Close",
    onSubmit: submitLrDeleteHandler,
    isLoadding: loadingLrDelete,
  }

  let builtyPrintModal = {
    isOpen: format?.lr_id,
    closeModal: (e) => setFormats(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Invoice LR POD",
    submitTitle: "Print Bilty",
    therdSubmitTitle: "Download",
    format: format,
    confirmBox: (e) => setShowLrPodModal(true)
  }

  let inoviceReportDownloadModal = {
    isOpen: openForDownLoad,
    closeModal: (e) => setOpenForDownLoad(false),
    modalMainClass: "_dashCommon_Modal _printViewModal _xxlModal",
    footerPart: true,
    modalTitle: "Invoice Report",
    submitTitle: "Download",
    therdSubmitTitle: "Download",
    invoice_id: billRaiseDetailsData?._id,
  }

  return (
    <div className='d-flex flex-column' style={{height:'calc(100vh - 55px)'}}>
      <ButtonHeading
        title={"Bill Raise"}
        exportLoading={invoiceLoading}
        Export={true}
        ExportSubmit={(e) => setShow(true)}
        Download={true}
        downloadSubmit={() => setOpenForDownLoad(true)}
      />

      <div className='_billRaise_dataTable'>
        <CustomTableNew
          columns={columns}
          data={apiData}
          filterableColumns={filterableColumns}
          isMasterFilter={isMasterFilter}
          currentPage={currentPage}
          totalPages={totalPages}
          totalRecords={totalRecords}
          onPageChange={handlePageChange}
          itemsPerPage={pageLimit}
          setColumns={(data) => updateLrColumns(data)}
          statusApiFilter={renderStatusFilters()}
          showDropdownFilters={showingDropdownFilters()}
          searchFilterOnChange={handleOnChange}
          isTableHide={isTableHide}
          resetLRTableColumn={(e) => resetLRTableColumn(e)}
          loading={loading}
          isResetAndFilter={true}
          deleteItem={true}
          deleteItemHandler={(value) => deleteItemHandler(value)}
          format={format}
          setFormats={(data) => setFormats(data)}
        />
      </div>

      {isTableHide && <>
        {loading ? <div className='p-4 d-flex h-100 justify-content-center align-items-center'><Loading /></div> : <BillSummaryDetails data={billRaiseDetailsData} filterData={isDropDownFilter} callInvoiceDetailsApi={(e) => callInvoiceDetailsApi(e)} />}
      </>}

      {
        isOpenInvoiceTemplate &&
        (
          <AddInvoiceTemplateModal {...AddtemplateInvoiceModal} />
        )
      }

      <div
        className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showLrDetail ? 'show' : ''}`}
        tabIndex={-1}
        style={{ visibility: showLrDetail ? 'visible' : 'hidden' }}
      >
        {showLrDetail
          && (
            <LrDetailModal
              isOpen={showLrDetail}
              onClose={(e) => setShowLrDetail(false)}
              hideEditButton={true}
            // nextModal={(e) => handleNextModal(e)}
            />
          )
        }
      </div>
      <div className={showLrDetail ? 'offBack_drop' : ''}></div>

      {show
        && (
          <InvoicePrintModal {...invoiceBuiltyPrintModal} />
        )
      }

      {showBackModal && (
        <ConfirmModalFor {...backModalProps}>
          <>
            <p className="_confirmPrx">You don't have any invoice format.</p>
          </>
        </ConfirmModalFor>
      )}

      {isOpenThankyouModal
        && (
          <ThankyouModal {...thankyouModalProps} />
        )
      }

      {
        lrDeleteConfirm?._id && (
          <CommonModal {...confirmObject}>
            <p className='p-3'> Are you sure you want to delete billraise ? </p>
          </CommonModal>
        )
      }

      {format?.lr_id
        && (
          <InvoiceLrPodModal {...builtyPrintModal} />
        )
      }

      {showLrPodModal && (
        <ConfirmModalFor {...invoiceLrPodProps}>
          <>
            <p className="_confirmPrx">You don't have any format.</p>
          </>
        </ConfirmModalFor>
      )}

      {openForDownLoad && <InvoiceReport {...inoviceReportDownloadModal} />}
    </div>
  )
}

export default BillRaiseDetails